import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct/lookup-cvr-add-address'

export default ($axios) => ({

  /**
   * This method gets the  address from the CVR registry for the given CVR number and updates the cart in CommerceTools
   */
  lookupCvrAndAddAddress(cvrNumber, cartID) {
    return $axios.post(`${resource}`, { cvrNumber, cartID })
  }

})
